import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import InstructionalText from '../notifications/InstructionalText';
import UniversalInput from '@lib/wrappers/UniversalInput';

// ActionCreators and Selectors

import { changeData } from '@actions/ssap/ssapActionCreators';
import { getIsState } from '@reducers/appReducer';

// Utils

import { cloneObject } from '@utils/miscellaneous/cloneObject';
import { dataSyncingTools } from '@utils/tools/dataSyncingTools';
import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';



const Page2_25 = props => {

    const {
        data,
        data: {
            taxHousehold: {
                thCommonParams: {
                    hasSomeoneHonorablyDischargedOrActiveDutyMilitary
                }
            }
        },
        householdMembers,
        formName
    } = props;

    const isState = useSelector(getIsState);

    const onFieldChange = (...args) => {

        let [ newData, indexInArray, , [  name, value ]  ] = args;

        switch(true) {
            case name.startsWith('hhm'):
                newData
                    .taxHousehold
                    .householdMember[indexInArray]
                    .citizenshipImmigrationStatus
                    .honorablyDischargedOrActiveDutyMilitaryMemberIndicator = value;

                newData = dataSyncingTools.syncThCommonProps(newData, {
                    propName: 'military'
                });
                break;

            case name === 'hasSomeoneHonorablyDischargedOrActiveDutyMilitary':
                newData = dataSyncingTools.syncThCommonProps(newData, {
                    isCommon: true,
                    propName: 'military'
                });
                break;
        }

        props.actions.changeData(newData);
    };

    const getContent = () => {

        const hhmsInputs = householdMembers.map((hhm, idx) => {
            const {
                citizenshipImmigrationStatus: {
                    honorablyDischargedOrActiveDutyMilitaryMemberIndicator: isMilitary,
                    livedIntheUSSince1996Indicator
                },
                name,
                applicantGuid,
            } = hhm;

            if(livedIntheUSSince1996Indicator !== false) {
                return null;
            }

            return (
                <UniversalInput
                    key = { applicantGuid }
                    label = { {
                        text: 'common.input.label.non_internationalized_text',
                        labelTextReplacements: {
                            text: normalizeNameOfPerson(name)
                        },
                        isLabelRequired: false
                    } }
                    inputData = { {
                        isInputRequired: false,
                        type: INPUT_TYPES.CHECKBOX,
                        name: `hhm_${ idx }`,
                        checked: isMilitary,
                        value: isMilitary,
                        currentData: cloneObject(data),
                        fields: [],
                    } }
                    inputActions = { {
                        onFieldChange
                    } }
                    indexInArray = { idx }
                />
            );
        });

        const noneOfAboveInput = (
            <UniversalInput
                key = 'hasSomeoneHonorablyDischargedOrActiveDutyMilitary'
                label = { {
                    text: 'ssap.input.label.none_of_above',
                    isLabelRequired: false
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.CHECKBOX,
                    name: 'hasSomeoneHonorablyDischargedOrActiveDutyMilitary',
                    checked: hasSomeoneHonorablyDischargedOrActiveDutyMilitary === false,
                    value: hasSomeoneHonorablyDischargedOrActiveDutyMilitary === false,
                    currentData: cloneObject(data),
                    fields: [ 'taxHousehold', 'thCommonParams' ],
                    reversedValue: true
                } }
                inputActions = { {
                    onFieldChange
                } }
            />
        );
        return [
            ...hhmsInputs,
            noneOfAboveInput
        ];
    };

    return (
        <div
            className = 'fade-in'
            id = 'fhMilitaryDuty'
        >
            <div className = 'subsection' >
                {
                    isState.NJ
                        ? (
                            <Fragment>
                                <FormattedMessage id = 'ssap.family_household.military_service.who_is_military' />
                                <div className = 'usa-alert usa-alert--info gi-alert gi-alert__info' >
                                    <div className = 'usa-alert__body gi-alert__info__body' >
                                        <p className = 'usa-alert__text gi-alert__info__text' >
                                            <FormattedMessage id = 'instructional_text.military_service_information' />
                                        </p>
                                    </div>
                                </div>
                            </Fragment>
                        )
                        : (
                            <InstructionalText
                                Component = {
                                    <p
                                        className = 'required-false'
                                        data-instructions = 'instructional_text.military_service_information' >
                                        { 'ssap.family_household.military_service.who_is_military' }
                                    </p>
                                }
                            />
                        )
                }
                <Form { ...{ formName } }>
                    { getContent() }
                </Form>
            </div>
        </div>
    );
};


const mapStateToProps = state => ({

    data: state.ssap.data,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember

});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page2_25);
